var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { rebillyConfigs } from '../../../utils/rebilly';
var RebillyContext = createContext(null);
export var RebillyProvider = function (_a) {
    var _b = _a.rebillyType, rebillyType = _b === void 0 ? 'live' : _b, children = _a.children;
    var config = rebillyConfigs.get(rebillyType);
    if (!config)
        throw new Error("Rebilly type \"".concat(rebillyType, "\" is not configured"));
    return _jsx(RebillyContext.Provider, __assign({ value: config }, { children: children }));
};
export var useRebilly = function () {
    var context = useContext(RebillyContext);
    if (!context)
        throw new Error('RebillyProvider not found in root');
    return context;
};
export var useSandbox = function () {
    var config = useRebilly();
    var isSandbox = config.stage === 'sandbox';
    return { isSandbox: isSandbox };
};
//# sourceMappingURL=Rebilly.js.map